import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import { Button } from "@mui/material";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./playVideo.scss";

const PlayGtakVideo = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const videoUrl = state?.video?.videoUrl || "";

  return (
    <div className="newNews">
      <Sidebar />
      <div className="newNewsContainer">
        <Navbar />
        <div className="videoWrapper">
          <Button
            variant="contained"
            className="backButton"
            onClick={() => navigate(-1)}
          >
            ← Back
          </Button>
          <ReactPlayer
            url={videoUrl}
            controls
            width="100%"
            height="100%"
            className="videoPlayer"
          />
        </div>
      </div>
    </div>
  );
};

export default PlayGtakVideo;
